export const faqs = [
  {
    q: "Why use simulated data?",
    a: "Primary research is only as good as the sample population.  One of the strengths of the Generative Insight approach is that insights are rooted in global LLMs, trained on hundreds of millions of people.  Their attitudes, motivations, reasoning and points of view are all codified and available for thoughtful interrogation"
  },
  {
    q: "What about qualitative research, such as focus groups?",
    a: "Any avatar in the research sample may be interviewed (e.g., ethnographic studies) individually, or as part of a group discussion (i.e., a focus group).  We are developing a framework and UI for conducting avatar-only focus groups"
  },
  {
    q: "Can you implement experimental designs?",
    a: "This is in the works.  At the moment, the platform only supports traditional surveys, with simple branching logic.  The roadmap includes the introduction of more complex exercises, such as conjoint (discrete choice) and max-diff"
  },
  {
    q: "How does the platform handle fast-moving changes to public sentiment?",
    a: "Our proprietary LLMs are refreshed in real time, and we do quarterly refreshes of the profile data in our sampling database.  In addition, “snapshots” of avatar profiles may be created periodically, enabling over-time comparisons of the shifting views of each segment"
  },
  {
    q: "Can we use an existing segmentation framework?",
    a: "Yes, of course!  Keep in mind that the accuracy and reliability of the avatar’s persona are influenced by the amount of data that describes each segment… segment profiles are ideally calibrated with robust research data"
  },
  {
    q: "Can we sample users of our product or service?",
    a: " Yes.  As we specify the target universe within the platform, we can specify segments that have experience with products of interest"
  }
];
